import { useMutation } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';
import { createQueryStringUtility } from '@/common/utils/create-query-string.utility';

interface CreateBasketPayloadType {
  vendorId: number | undefined | null;
  command: CommandType[];
}

interface CommandType {
  productVariantId: number;
  count: number;
}

type CreateBasketType = (params: CreateBasketPayloadType) => Promise<[]>;

const createBasketApi: CreateBasketType = async (
  payload: CreateBasketPayloadType
) => {
  const client = new Client();
  const vendorId = payload.vendorId || 0;
  return await client.post(
    `/v1/Basket/Shopper/CreateBasket/${createQueryStringUtility({ vendorId })}`,
    payload.command
  );
};

export const useCreateBasket = () => {
  return useMutation({
    mutationFn: createBasketApi,
    retry: 1,
  });
};
